import { useEffect, useState } from 'react'
import contractApi from 'services/api/contracts'

import Box from '../Box'
import DocumentTile from './DocumentTile'

/**
 * @typedef {object} Document
 * @property {number} documentId
 * @property {string} name
 * @property {string} path
 * @property {string} contentType
 * @property {string} addedOn
 * @property {string} updatedOn
 * @property {string} updatedUser
 * @property {string} addedUser
 * @property {string} kind
 */

/**
 * @typedef {Object} Props
 * @property {string} merchantId
 * @property {(document: Document) => void} onClick
 *
 * @param {Props} props
 * @returns
 */
export default function MerchantDocuments(props) {
  const { onClick, merchantId } = props
  /**
   * @type {[Document[], React.Dispatch<Document[]>]} state
   */
  const [documents, setDocuments] = useState([])

  useEffect(() => {
    contractApi.documents
      .merchant(merchantId)
      .then(data => setDocuments(data || []))
      .catch(console.error)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Box title="Merchant Documents">
      {documents.length > 0 ? (
        <div
          style={{
            marginTop: 6,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            gap: 12
          }}
        >
          {documents.map(document => (
            <DocumentTile
              key={document.documentId}
              document={document}
              onClick={() => onClick(document)}
            />
          ))}
        </div>
      ) : (
        <p>No documents found</p>
      )}
    </Box>
  )
}
